import http from 'hub-http/clients/apiClient';
const BASE_URL = `api/consent-options/v1/settings/with-defaults/language`;
export const getLegalConsentCopy = ({
  language = 'en',
  businessUnitId = 0
}) => http.get(`${BASE_URL}/${language}`, {
  query: {
    businessUnitId
  }
});
export default getLegalConsentCopy;